
export enum ActionType {
    ON_MENU = 'ON_MENU'
}
